<template>
  <v-card class="cookie-card">
    <v-card-title class="text-h4 justify-center">{{
      $config.isMaBuBuild
        ? $t('cookies.dialog.welcomeMaBu')
        : $t('cookies.dialog.welcome')
    }}</v-card-title>
    <v-card-text class="grey-darken-4--text text-body-4 text-sm-body-3">
      <i18n path="cookies.dialog.content" tag="span">
        <span
          role="button"
          class="link-normal"
          @click="showAdvanceSettings = true"
          >{{ $t('cookies.dialog.linkText') }}</span
        >
      </i18n>
      <div v-if="showAdvanceSettings" class="grey-darken-4--text">
        <base-expansion-panel
          v-for="group in mappedCookieGroups"
          :key="group.id"
        >
          <template #title>
            <v-checkbox
              :ripple="false"
              :disabled="!!group.required"
              hide-details
              class="ma-0"
              :label="$t(`cookies.groups.${group.id}.name`)"
              :value="group.cookies.length === group.values.length"
              :input-value="group.cookies.length === group.values.length"
              :indeterminate="
                group.cookies.length !== group.values.length &&
                group.values.length !== 0
              "
              @change="setAllCookieInGroup(group.id, $event)"
              @click.stop=""
            ></v-checkbox>
          </template>

          {{ $t(`cookies.groups.${group.id}.description`) }}

          <div v-for="(cookie, index) in group.cookies" :key="index">
            <v-checkbox
              v-model="group.values"
              dense
              hide-details
              :ripple="false"
              :label="$t(`cookies.${cookie}`)"
              :value="cookie"
              :disabled="!!group.required"
            ></v-checkbox>
          </div>
        </base-expansion-panel>

        <base-button
          outlined
          small
          rounded
          class="mt-4 grey-darken-3--text"
          @click="save"
          >{{ $t('actions.save') }}</base-button
        >
      </div>
    </v-card-text>

    <v-card-actions class="px-2 pb-5 pt-0 justify-center">
      <base-button
        rounded
        large
        dynamic
        class="pink-berry white--text"
        @click="$emit('click:allowed-all')"
        >{{ $t('actions.acceptAll') }}</base-button
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import BaseExpansionPanel from '~/components/base/expansion/BaseExpansionPanel'
import BaseButton from '~/components/base/button/BaseButton'
export default {
  name: 'CookieDialogCard',
  components: { BaseButton, BaseExpansionPanel },
  props: {
    cookies: {
      type: Array,
      default: () => [],
    },
    cookieGroups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showAdvanceSettings: false,
      mappedCookieGroups: [],
    }
  },
  mounted() {
    this.mappedCookieGroups = this.cookieGroups.map((group) => {
      return {
        ...group,
        values: group.cookies.filter(
          (cookie) => group.required || this.cookies.includes(cookie)
        ),
      }
    })
  },
  methods: {
    setAllCookieInGroup(groupId, val) {
      const group = this.mappedCookieGroups.find(({ id }) => id === groupId)

      group.values = val ? [...group.cookies] : []
    },
    save() {
      const values = this.mappedCookieGroups.map(({ values }) => values).flat(1)

      this.$emit('save', [...values])
    },
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.cookie-card {
  .v-input,
  .v-label,
  .v-label--is-disabled {
    font-weight: 400 !important;
    color: map-get($shades, 'grey-darken-4') !important;
  }
}
</style>
